import type { z } from 'zod';
import { categorySchema } from '@/entities/shared/category/category';
import { prioritySchema } from '@/entities/shared/priority/priority';
import { centsField } from '@/entities/shared/schemas/cents-field';
import { isoDateField } from '@/entities/shared/schemas/iso-date-field';
import { longTextField } from '@/entities/shared/schemas/long-text-field';
import { nameField } from '@/entities/shared/schemas/name-field';
import { shortTextField } from '@/entities/shared/schemas/short-text-field';
import { zs } from '@/entities/shared/schemas/zod';
import { shoppingStatusSchema } from './shopping-status';

/** Something to buy, with what we think it will cost. Mirrors …/collections/shopping_item.py. */
export const shoppingItemSchema = zs.looseObject({
  name: nameField,
  category: categorySchema.default('other'),
  quantity: zs.number().gt(0).default(1),
  unit: shortTextField.default('ud'),
  estimated_price_cents: centsField.optional(),
  priority: prioritySchema.default('medium'),
  status: shoppingStatusSchema.default('pending'),
  store: shortTextField.optional(),
  url: zs.string().trim().max(2000).optional(),
  needed_by: isoDateField.optional(),
  bought_on: isoDateField.optional(),
  price_cents: centsField.optional(),
  item_id: zs.uuid().optional(),
  notes: longTextField.optional(),
});

export type ShoppingItem = z.infer<typeof shoppingItemSchema>;
